export default __webpack_public_path__ + "5a0b0da3f40ff1c822f87851353ca755.png";